// extracted by mini-css-extract-plugin
module.exports = {"container":"JourneyCreate_container__1fSoz","text":"JourneyCreate_text__23jDm"};